/**
 * Shared row-click selection behaviour for multi-select tables.
 *
 * The reference implementation grew up in the time-entries list: a row
 * toggles its checkbox when you click any "dead" spot on it, while every
 * interactive element inside the row (links, buttons, inputs, pickers,
 * dialogs…) keeps working untouched — no stopPropagation games, the row
 * handler just inspects the click target against a guard selector.
 *
 * Use `rowClickProps(toggle)` on the `<TableRow>`; keep the checkbox's own
 * onChange — `input` matches the guard, so it never double-toggles.
 */

export const ROW_CLICK_GUARD_SELECTOR =
  "a, button, input, select, textarea, label, [role='button'], [role='combobox'], [role='menuitem'], [role='dialog']";

export function rowClickProps(toggle: () => void): {
  onClick: (e: React.MouseEvent) => void;
  className: string;
} {
  return {
    onClick: (e) => {
      const target = e.target as HTMLElement;
      if (target.closest(ROW_CLICK_GUARD_SELECTOR)) return;
      toggle();
    },
    className: "cursor-pointer",
  };
}
